// src/i18n/locales/man.js

export default {
  countries: {
    'AF': 'Afiganistan',
    'AL': 'Albaniya',
    'DZ': 'Aljeriya',
    'AD': 'Andora',
    'AO': 'Angola',
    'AG': 'Antiguwa ning Barbuda',
    'AR': 'Arajantina',
    'AM': 'Armeniya',
    'AU': 'Ostaraliya',
    'AT': 'Ostiriya',
    'AZ': 'Azerbayijan',
    'BS': 'Bahamas',
    'BH': 'Baharayin',
    'BD': 'Bangalades',
    'BB': 'Barbados',
    'BY': 'Belaarus',
    'BE': 'Beljiyom',
    'BZ': 'Beliiz',
    'BJ': 'Benin',
    'BT': 'Butan',
    'BO': 'Boliviya',
    'BA': 'Bosniya ning Herjegovina',
    'BW': 'Botosowana',
    'BR': 'Baraazil',
    'BN': 'Burunay',
    'BG': 'Bulgariya',
    'BF': 'Burukina Faso',
    'BI': 'Burundi',
    'CV': 'Kabo Verde',
    'KH': 'Kambodiya',
    'CM': 'Kamerun',
    'CA': 'Kanada',
    'CF': 'Sentaral Afrika',
    'TD': 'Caad',
    'CL': 'Cili',
    'CN': 'Siin (China)',
    'CO': 'Kolombiya',
    'KM': 'Komoros',
    'CG': 'Kongo',
    'CD': 'Kongo (Repubilik Demokaraatik)',
    'CR': 'Kosatarika',
    'CI': 'Kodiwar',
    'HR': 'Korowasiya',
    'CU': 'Kuba',
    'CY': 'Sipirus',
    'CZ': 'Cekiya',
    'DK': 'Denmark',
    'DJ': 'Jibuti',
    'DM': 'Dominika',
    'DO': 'Dominikan Repubilik',
    'EC': 'Ekuwador',
    'EG': 'Misira (Egypt)',
    'SV': 'El Salvador',
    'GQ': 'Ekuwatoriyal Gini',
    'ER': 'Eritereya',
    'EE': 'Estoniya',
    'ET': 'Etiyopiya',
    'FJ': 'Fiji',
    'FI': 'Finland',
    'FR': 'Faraansi',
    'GA': 'Gabon',
    'GM': 'Gambiya',
    'GE': 'Jorjiya',
    'DE': 'Alimaañ (Germany)',
    'GH': 'Gaana',
    'GR': 'Giris',
    'GD': 'Girenada',
    'GT': 'Guwatemala',
    'GN': 'Gini',
    'GW': 'Gini-Bisawu',
    'GY': 'Guyana',
    'HT': 'Hayiti',
    'HN': 'Honduras',
    'HU': 'Hungari',
    'IS': 'Aysiland',
    'IN': 'Indiya',
    'ID': 'Indonesiya',
    'IR': 'Iraan',
    'IQ': 'Iraak',
    'IE': 'Irland',
    'IL': 'Isirayil',
    'IT': 'Itali',
    'JM': 'Jamayika',
    'JP': 'Japaan',
    'JO': 'Jordan',
    'KZ': 'Kajakistan',
    'KE': 'Keniya',
    'KI': 'Kiribati',
    'KP': 'Koreya (Kojang)',
    'KR': 'Koreya (Batoo)',
    'KW': 'Kuweyt',
    'KG': 'Kirigistan',
    'LA': 'Lawos',
    'LV': 'Lativiya',
    'LB': 'Liban',
    'LS': 'Lesoto',
    'LR': 'Liberiya',
    'LY': 'Libiya',
    'LI': 'Likitenstayin',
    'LT': 'Lituwaniya',
    'LU': 'Likisamburg',
    'MG': 'Madagaskar',
    'MW': 'Malawi',
    'MY': 'Maleesiya',
    'MV': 'Maldiifs',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marsal Tundol',
    'MR': 'Moritani',
    'MU': 'Morisiyos',
    'MX': 'Meksiko',
    'FM': 'Mikoronesiya',
    'MD': 'Molodova',
    'MC': 'Monako',
    'MN': 'Mongoliya',
    'ME': 'Montenegro',
    'MA': 'Marok',
    'MZ': 'Mojambik',
    'MM': 'Miyanmar',
    'NA': 'Namibiya',
    'NR': 'Nawuru',
    'NP': 'Nepaal',
    'NL': 'Nedalands',
    'NZ': 'Niwu Jiland',
    'NI': 'Nikaraguwa',
    'NE': 'Nijeyr',
    'NG': 'Nijeriya',
    'MK': 'Masedoniya',
    'NO': 'Norwey',
    'OM': 'Oman',
    'PK': 'Pakistaan',
    'PW': 'Palawu',
    'PS': 'Falastin',
    'PA': 'Panama',
    'PG': 'Papuwa Niwu Gini',
    'PY': 'Paraguwey',
    'PE': 'Peru',
    'PH': 'Filipins',
    'PL': 'Polan',
    'PT': 'Portugaal',
    'QA': 'Katar',
    'RO': 'Romaniya',
    'RU': 'Rusiya',
    'RW': 'Ruwanda',
    'KN': 'Sent Kits ning Nevis',
    'LC': 'Sent Lusiya',
    'VC': 'Sent Vinsent ning Girenadins',
    'WS': 'Samowa',
    'SM': 'San Marino',
    'ST': 'Sawo Tome ning Pirinsipe',
    'SA': 'Sawudi Arabiya',
    'SN': 'Senegaal',
    'RS': 'Serbiya',
    'SC': 'Sesels',
    'SL': 'Siyera Leyon',
    'SG': 'Singapur',
    'SK': 'Silovakiya',
    'SI': 'Siloveniya',
    'SB': 'Solomon Tundol',
    'SO': 'Somaliya',
    'ZA': 'Safrika',
    'SS': 'Sudan Batoo',
    'ES': 'Sipeen',
    'LK': 'Siri Lanka',
    'SD': 'Sudan',
    'SR': 'Surinam',
    'SZ': 'Eswatini',
    'SE': 'Suwiden',
    'CH': 'Suwiselan',
    'SY': 'Siriya',
    'TJ': 'Tajikistan',
    'TZ': 'Tanjaniya',
    'TH': 'Tayiland',
    'TL': 'Timor',
    'TG': 'Togo',
    'TO': 'Tonga',
    'TT': 'Tirinidad ning Tobago',
    'TN': 'Tunisiya',
    'TR': 'Turki',
    'TM': 'Turukimenistan',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukeren',
    'AE': 'Imaaraat',
    'GB': 'Angalteer',
    'US': 'Ameriki (US)',
    'UY': 'Uruguwey',
    'UZ': 'Ujibekistan',
    'VU': 'Vanuwatu',
    'VA': 'Vatikan Siti',
    'VE': 'Venejuwela',
    'VN': 'Viyetinam',
    'YE': 'Yemen',
    'ZM': 'Jambiya',
    'ZW': 'Jimbabuwe'
  },
  verification: {
    verifying: 'I la imeeloo ka kumpabo...',
    success: 'Imeeloo kumpabota a benta!',
    failed: 'Kumpaboo mang ben',
    accountVerified: 'I la akaanti kumpabota a benta. I si waasa ka dung i la akaanti kono saaying.',
    invalidLink: 'Kumpabo linkoo man faa, wala a waatoo tambita.',
    missingToken: 'Kumpabo tokinoo mang je.',
    generalError: 'Filiyata kumpaboo to. I si a ñining tugung.',
    proceedToLogin: 'Taa long in to',
    backToLogin: 'Murung long in to'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Dasboodoo',
    system: 'Sistemoo',
    settings: 'Setinsi (Kilaatol)',
    overview: 'Kijeraa',
    database: 'Detabeesi',
    logs: 'Logolu',
    userManagement: 'Moo-kiliya lataramoo',
    security: 'Kantari',
    systemAdministration: 'Sistem Lataramoo',
    loading: 'A ka looti...',
    close: 'Dasboodoo dade',
    edit: 'A dada',
    systemUptime: 'Sistemoo baara-waatoo',
    avgResponseTime: 'Jaabi-waatoo teema',
    errorRate: 'Filiya-kilaa',
    activeUsers: 'Moo baarakilaalu',
    monthlyActiveUsers: 'Kalo-kalo moo baarakilaalu (MAU)',
    fromLastMonth: 'kalo tambita koto',
    today: 'Bii',
    tabs: {
      overview: 'Sistem Kendeyaa',
      hierarchy: 'Longo jukutol',
      documents: 'Dokuuma lataramoo',
      database: 'Detabeesi',
      logs: 'Logolu',
      security: 'Kantari',
      users: 'Moolu'
    },
    contentManagement: "KONTENTI LATARAMOO",
    knowledgeHierarchy: "Longo jukutol",
    documentManagement: "Dokuuma Lataramoo",
    noLogsFound: "Logolu mang je bii",
    invalidLogsResponse: "Logolu jaabi coko mang faa",
    logsSummaryError: "Logolu kijeraa lootoo mang ben",
    buttons: {
      save: "A mara",
      cancel: "A bula",
      switch: "A faling",
      discard: "A fiti"
    },
    confirm: {
      defaultTitle: "A kumpabo",
      defaultMessage: "I lafiya le ti?"
    },
    systemHealthStatus: 'Sistemoo Kendeya coko',
    runDiagnostics: 'Fili-ñiningo ke',
    resourceUsage: 'Risoosi baara-coko',
    services: {
      apiServices: 'API baaarol',
      database: 'Detabeesi',
      cache: 'Kaas (Cache)',
      storage: 'Maradaa',
      messageQueue: 'Kilaa lo-da',
      externalApi: 'Banta API'
    },
    resources: {
      cpu: 'CPU baara-coko',
      memory: 'Memori baara-coko',
      storage: 'Maradaa baara-coko',
      network: 'Netwookoo kandaa'
    },
    databaseManagement: 'Detabeesi Lataramoo',
    reindexDatabase: 'Detabeesi indexi kura',
    lastReindex: 'Indexi kura labang',
    databaseSize: 'Detabeesi warayaa',
    totalTables: 'Tebulol bee kafung',
    logManagement: 'Log Lataramoo',
    rolloverLogs: 'Logolu murung',
    searchLogs: 'Logolu ñining',
    logTime: 'Waatoo',
    logLevel: 'Kafo-jukuto (Level)',
    logService: 'Baara',
    logMessage: 'Kilaa',
    showingEntries: 'A ka yitandi {start}-{end} to {total} moolu bee to',
    logLevels: {
      error: 'FILIYATA (ERROR)',
      warn: 'KANKUTAY (WARN)',
      info: 'KIBARO (INFO)',
      debug: 'FILI-DADA (DEBUG)'
    },
    logMessages: {
      connectionTimeout: 'Taa banta-diilaa to mang joona',
      lowDiskSpace: 'Maradaa koto dooyata tambi 10%',
      userRoleUpdated: 'Moo-kiliya jukuto yailamata admin@huduma.ai ye'
    },
    userName: 'Toh',
    userEmail: 'Imeeloo',
    userRole: 'Moo-jukuto',
    userStatus: 'Cokoyaa',
    userActions: 'Kewol',
    roleAdministrator: 'Adimin (Kuntii)',
    roleUser: 'Moo (User)',
    statusActive: 'A ka baara',
    dbActions: {
      reindex: 'Indexi kura',
      backup: 'Bakaap (Mara)',
      optimize: 'A dadiyaa',
      reindexDesc: 'Detabeesi indexolu lo-kura',
      backupDesc: 'Detabeesi marol ke',
      optimizeDesc: 'Koori baara-coko dadiyaa'
    },
    operations: {
      reindexTitle: 'Detabeesi Indexi kura Fata',
      backupTitle: 'Detabeesi Mara Fata',
      optimizeTitle: 'Detabeesi Dadiyaa Fata',
      reindexResults: 'Indexi kura Fatal',
      optimizeResults: 'Dadiyaa Fatal',
      collection: 'Kafung-da',
      status: 'Cokoyaa',
      indexSuggestions: 'Indexi nimal',
      backupDetails: 'Mara kumpa-kumol',
      backupFile: 'Mara Fayiloo',
      backupLocation: 'Dulaa',
      backupSize: 'Warayaa',
      errorDetails: 'Filiya kumpa-kumol',
      close: 'A dade',
      resultsTitle: 'Baara Fatal',
      reindexDatabase: {
        success: 'Detabeesi indexi kura benta',
        error: 'Filiyata detabeesi indexi kura to',
        loading: 'A ka detabeesi indexi kura...'
      },
      backupDatabase: {
        success: 'Detabeesi mara benta',
        error: 'Filiyata detabeesi mara to',
        loading: 'A ka detabeesi mara ke...'
      },
      optimizeDatabase: {
        success: 'Detabeesi dadiyaa benta',
        error: 'Filiyata detabeesi dadiyaa to',
        loading: 'A ka detabeesi dadiyaa...'
      },
      rolloverLogs: {
        success: 'Log murung-murung benta',
        loading: 'A ka logolu murung-murung...'
      },
      searchLogs: {
        success: 'Log ñiningo benta',
        loading: 'A ka logolu ñining...'
      },
      runDiagnostics: {
        success: 'Fili-ñiningo benta',
        loading: 'A ka fili-ñiningo ke...'
      },
      runSecurityScan: {
        success: 'Kantari ñiningo benta',
        loading: 'A ka kantari ñiningo ke...'
      },
      cancel: 'A bula',
      save: 'Yailamawol mara'
    },
    userManagementSection: {
      totalUsers: 'Moolu bee kafung',
      newUsers: 'Moo kural (Kalo)',
      searchUsers: 'Moolu ñining...',
      clearSearch: 'Ñiningo fiti',
      search: 'Ñining',
      usersFound: 'moolu jeta',
      showAllUsers: 'Moolu bee yitandi',
      searching: 'A ka ñining...',
      searchingUsers: 'A ka moolu ñining...',
      noUsersFound: 'Moo ti je min faata i la ñiningo to.',
      noUsers: 'Moo te jang.',
      showing: 'Ka yitandi',
      of: 'to',
      previous: 'A koto',
      next: 'A noomata',
      searchFields: {
        all: 'Dulaalu bee',
        name: 'Toh',
        email: 'Imeeloo',
        role: 'Moo-jukuto'
      },
      userSearch: {
        resultsFound: 'Moolu {total} jeta min benta ning "{term}"',
        error: 'Filiyata moo ñiningo to'
      }
    },
    logsSection: {
      errorLogs: 'Filiya Logolu',
      warningLogs: 'Kankutay Logolu',
      noErrorLogs: 'Filiya log mang mara bii.',
      noWarningLogs: 'Kankutay log mang mara bii.',
      infoLogsNote: 'Kibaro logolu ti yitandi kijeraa to. Baara ñiningo la nga log suwol bee je.',
      searchResults: 'Ñining Fatal labang',
      entriesFound: 'suw je',
      viewAllResults: 'Fatal bee je',
      logType: 'Suko',
      logCount: 'Konto',
      logTypes: {
        connectionTimeout: 'Kafung mang joona',
        databaseFailed: 'Detabeesi ñiningo ti ben',
        authFailed: 'Dung-kumpaboo ti ben',
        lowDiskSpace: 'Maradaa koto dooyata',
        slowQuery: 'Ñiningo dooyata',
        rateLimit: 'Tambi-da ka sutiyaa'
      },
      logSearch: {
        noResultsFound: 'Log te min benta i la ñiningo to',
        resultsFound: 'Log suw {count} jeta'
      }
    },
    security: {
      title: 'Kantari Kumpaboo',
      securityScan: 'Kantari Ñiningo',
      runningSecurityScan: 'A ka ñiningo ke...',
      lastSecurityScan: 'Kantari Ñiningo labang',
      vulnerabilitiesFound: 'Filiyal/Koyal jeta',
      daysAgo: 'tilung tambita',
      critical: 'toro-baa (critical)',
      medium: 'toro-teema (medium)',
      low: 'toro-doo (low)',
      failedLoginAttempts: 'Long in mang ben (24h)',
      suspiciousActivities: 'Baara sikiyantal (24h)',
      securityRecommendations: 'Kantari Nimalolu',
      criticalVulnerabilities: 'Filiya toro-baa',
      mediumVulnerabilities: 'Filiya toro-teema',
      lowVulnerabilities: 'Filiya toro-doo',
      authenticationIssues: 'Dung-kumpabo kuraalu',
      suspiciousActivityLogs: 'Baara sikiyantal logolu',
      securityProbeAttempts: 'Kantari ñining-kataa jeta',
      sensitiveFileAccess: 'kataa ka dokuuma kantata je',
      envFileAccess: 'Envayro Fayil kataa',
      envFileAccessDesc: 'kataa ka .env fayilolu je',
      gitRepoAccess: 'Git Repositri kataa',
      gitRepoAccessDesc: 'kataa ka Git repositri fayilolu je',
      recommendedAction: 'Kewol Nimalolu',
      rateLimitRecommendation: 'Hali ka tambi-da muta, IP kandi mutol ye, ani ibay ka i la sistemoo bambang.',
      envFileRecommendation: 'A kumpabo ko envayro fayilolu man nanta banta web dulaa to ani ka kang ka dulaa kantata muta.',
      gitRepoRecommendation: 'A kumpabo ko .git dulaalu kantata le banta web to.',
      noVulnerabilitiesFound: 'Filiyal/Koyal mang je',
      systemSecure: 'I la sistemoo kantata le baa. Hali ka kumpabo luming.',
      loadingScan: 'Ñining fatal ka looti...',
      occurrences: 'A keta ñaa',
      firstSeen: 'A jeta folo',
      lastSeen: 'A jeta labang',
      timestamp: 'Waatoo',
      message: 'Kilaa',
      service: 'Baara',
      type: 'Suko',
      severity: 'Toro-kandaa',
      url: 'URL (Luka)',
      matchedTerm: 'Kuma benta',
      lineNumber: 'Layini conto',
      lineNumbers: 'Layini contol',
      showLess: 'A dooya ka yitandi',
      showMore: 'Kuraal bee yitandi',
      lastScanJustNow: "Saaying-saaying"
    },
    userEdit: {
      title: 'Moo Dada',
      loading: 'Moo la kuma ka looti...',
      userInfo: 'Moo Kibaroo',
      userId: 'Moo ID',
      loginName: 'Long in Toh',
      fullName: 'Toh faata',
      dob: 'Bulu-lung',
      email: 'Imeeloo',
      emailVerified: 'Imeeloo Kumpabota',
      verified: 'Kumpabota le',
      notVerified: 'Mang kumpabo',
      createdAt: 'A dada-lung',
      lastLogin: 'Long in labang',
      never: 'Abada (Never)',
      accountSettings: 'Akaanti Setinsi',
      accountStatus: 'Akaanti Cokoyaa',
      accountEnabled: 'Akaanti Bulata',
      cannotDisableSelf: 'Ite mang si i la akaanti bulandi',
      accountRole: 'Akaanti Jukuto',
      adminRole: 'Adimin Jukuto',
      cannotChangeOwnRole: 'Ite mang si i la jukuto yailama',
      adminActions: 'Adimin Kewol',
      verifyEmail: 'Imeeloo Kumpabo',
      resetPassword: 'Paswoodoo Kurandi kilaa',
      forceLogout: 'A bong banta',
      failedToLoad: 'Moo la kuma lootay mang ben',
      errorLoading: 'Filiyata moo la kuma lootay to',
      saveSuccess: 'Moo setinsi marata benta',
      errorSaving: 'Filiyata moo setinsi mara to',
      verifyEmailSuccess: 'Kumpabo imeeloo kiyata benta',
      emailVerificationFailed: 'Kumpabo imeeloo kilaa mang ben',
      errorVerifyingEmail: 'Filiyata kumpabo imeeloo kilaa to',
      passwordResetSent: 'Paswoodoo kurandi imeeloo kiyata',
      passwordResetFailed: 'Paswoodoo kurandi kilaa mang ben',
      errorSendingReset: 'Filiyata paswoodoo kurandi kilaa to',
      logoutForced: 'Moo bong-ta banta',
      logoutFailed: 'A bong banta mang ben',
      errorForcingLogout: 'Filiyata a bong banta to',
      userUpdated: "Moo dada benta"
    },
    hierarchy: {
      title: "Longo Jukutol Lataramoo (tu Angaleeto - ka farikung/tradiksion dila)",
      addCategory: "Katifo Kura Kafu",
      loading: "Jukutol ka looti...",
      addService: "Baara Kafu",
      editCategory: "Katifo Dada",
      deleteCategory: "Katifo Fiti",
      editService: "Baara Dada",
      deleteService: "Baara Fiti",
      empty: 'Katifo mang je. Piti "Katifo Kura Kafu" ka a damina.',
      formTitleCreateCategory: "Katifo Kura Dada",
      formTitleAddService: "Baara Kafu \"{categoryName}\" to",
      formTitleEditCategory: "Katifo Dada: \"{itemName}\"",
      formTitleEditService: "Baara Dada: \"{itemName}\"",
      nameEnLabel: "Toh (Angalee)",
      translationsTitle: "Farikung/Tradiksion yitandili",
      loadingTranslations: "Tradiksion ka looti...",
      selectLang: "Kangoo Ceng",
      translationPlaceholder: "Tradiksion nyiningo",
      deleteTranslation: "Tradiksion Fiti",
      addTranslation: "+ Tradiksion Kafu",
      saveSuccess: "Jukuto feng marata benta.",
      saveError: "Filiyata jukuto feng mara to.",
      loadError: "Filiyata longo jukutol looti to.",
      loadTranslationsError: "Filiyata tradiksion looti to.",
      confirmCancelTitle: "Yailama-mang-mara",
      confirmCancelEdit: "I la yailamawol ti mara folo. I lafiya la a bula le ti?",
      confirmDeleteTitleCategory: "Katifo Fiti?",
      confirmDeleteTitleService: "Baara Fiti?",
      confirmDeleteCategory: "I lafiya la ka Katifo \"{itemName}\" fiti le ti? Nying kwoo mang si murung.",
      confirmDeleteService: "I lafiya la ka Baara \"{itemName}\" fiti le ti? Nying kwoo mang si murung.",
      deleteSuccessCategory: "Katifo fitita benta.",
      deleteSuccessService: "Baara fitita benta.",
      deleteErrorCategory: "Katifo fitita mang ben.",
      deleteErrorService: "Baara fitita mang ben.",
      duplicateLangError: "Kango kilin-kilin naata tradiksion to. A bong banta."
    },
    documents: {
      title: "Dokuuma Lataramoo",
      addLink: "A kafu linkoo la",
      uploadFiles: "Fayilolu Yele",
      searchPlaceholder: "Fayil toh nyining...",
      allStatuses: "Cokoyaa bee",
      statusPending: "A ka munu",
      statusIngested: "A dunta",
      statusRetracted: "A botata",
      statusIngesting: "A ka dung",
      statusError: "Dunta Filiyata",
      statusWarning: "A dunta ning kankutay",
      ingestSelected: "Cengo Dung",
      colFileName: "Fayil Toh",
      colStatus: "Cokoyaa",
      colLabels: "Mata-kumol",
      colUploadDate: "Yele Lung",
      colSize: "Warayaa",
      loading: "Dokuumalu ka looti...",
      empty: "Dokuuma mang je.",
      loadError: "Dokuumalu lootay mang ben.",
      confirmIngestTitle: "Kafung-Dung Kumpabo",
      ingest: "Dung",
      confirmIngestSelected: "I lafiya la ka fayil cengo {count} dung le ti?",
      ingestQueuedSuccess: "Fayil {count} laata ka dung.",
      ingestQueuedError: "Filiyata kafung-dung to.",
      uploadSuccessMultiple: "Fayil {count} yeleta benta.",
      linkSubmitSuccess: "\"{fileName}\" ñiningta ani a marata benta.",
      actionSuccess: "Baara \"{action}\" fayil {fileId} to benta.",
      metadataUpdateSuccess: "Metadeta fayil {fileId} yailamata."
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Paswoodoo Kura Dada',
    tokenLabel: 'Riset Tokin',
    tokenPlaceholder: 'Riset Tokin nyiningo',
    validateButton: 'Tokin Kumpabo',
    newPasswordLabel: 'Paswoodoo Kura',
    newPasswordPlaceholder: 'Paswoodoo kura dada',
    confirmNewPasswordLabel: 'Paswoodoo Kura Kumpabo',
    confirmNewPasswordPlaceholder: 'I la paswoodoo kura kumpabo',
    resetButton: 'Paswoodoo Kurandi',
    processing: 'A ka baara...',
    rememberedPassword: 'I hakili toota i la paswoodoo to?',
    backToLogin: 'Murung Long in to',
    supportMessage: 'Dimba lafiya? Mbe makaamoo kili',
    passwordRequirements: 'Paswoodoo nanta ka ke sifar 8, a ning konto 1, sifar-baa 1, ani sifar-suko 1',
    passwordsDoNotMatch: 'Paswoodolu mang ben',
    resetSuccess: 'I la paswoodoo kurandita benta',
    resetFailed: 'Paswoodoo kurandi mang ben. I si a ñining tugung.',
    noTokenProvided: 'Ibay dii Riset Tokin',
    expiredToken: 'Nying Riset Tokin tambita. Ñiningo kura ke.',
    invalidToken: 'Riset Tokin mang je wala a mang faa',
    validatingToken: 'Tokin ka kumpabo...',
    redirecting: 'A ka taa long in dulaa to...',
    passwordStrength: 'Paswoodoo Bambang-coko',
    strengthLabels: {
      veryWeak: 'A yendayata le baa',
      weak: 'A yendayata',
      fair: 'A dooyata teema',
      good: 'A benta',
      strong: 'A bambangta'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Baara sifar 8 silango',
      addUppercase: 'Sifar-baa kafu',
      addLowercase: 'Sifar-doo kafu',
      addNumbers: 'Konto kafu',
      addSpecialChars: 'Sifar-suko kafu'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'I la Paswoodoo Kurandi',
    emailLabel: 'Imeeloo dulaa',
    emailPlaceholder: 'I la imeeloo nyining',
    resetButton: 'Riset Linkoo Kii',
    processing: 'A ka kii...',
    rememberPassword: 'I hakili toota i la paswoodoo to?',
    backToLogin: 'Murung Long in to',
    supportMessage: 'Dimba lafiya? Mbe makaamoo kili',
    invalidEmail: 'Ibay dii imeeloo ceng-ceng',
    resetRequestSuccess: 'Paswoodoo kurandi linkoo kiyata i la imeeloo to',
    resetRequestFailed: 'Paswoodoo kurandi linkoo kii mang ben. I si a ñining tugung.',
    checkEmail: 'I la imeeloo kumpabo kuraalu ye.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Akaanti Kura Dada",
    username: "Toh-kilaa (Username)",
    usernamePlaceholder: "Toh-kilaa nyining",
    email: "Imeeloo",
    emailPlaceholder: "I la imeeloo nyining",
    password: "Paswoodoo",
    passwordPlaceholder: "Paswoodoo dada",
    confirmPassword: "Paswoodoo Kumpabo",
    confirmPasswordPlaceholder: "I la paswoodoo kumpabo",
    acceptTerms: "N sota",
    termsOfService: "Baara Saratol",
    registerButton: "Akaanti Dada",
    processing: "A ka baara...",
    alreadyHaveAccount: "I sota akaanti le?",
    loginNow: "Long in saaying",
    privacyNotice: "I la akaanti dada-to, i sota nna Baara Saratol ani Sutura Lataramoo to",
    usernameMinLength: "Toh-kilaa nanta ka ke sifar 3",
    invalidEmail: "Ibay dii imeeloo ceng-ceng",
    passwordRequirements: "Paswoodoo nanta ka ke sifar 8, a ning konto 1 ani sifar-baa 1",
    passwordsDoNotMatch: "Paswoodolu mang ben",
    mustAcceptTerms: "I nanta sota Baara Saratol ye",
    registrationFailed: "Akaanti dada mang ben. I si a ñining tugung.",
    usernameExists: "Nying Toh-kilaa sota",
    emailExists: "Nying Imeeloo sota",
    registrationSuccess: "Akaanti dada benta!",
    verificationEmailSent: "Kumpabo imeeloo kiyata {email} to",
    checkEmailInstructions: "I la imeeloo kumpabo ani nooma kililaa ka i la akaanti kumpabo folo i ye long in.",
    backToLogin: "Murung Long in to",
    noEmailReceived: "I ti imeeloo je?",
    resendVerification: "Kumpabo imeeloo murung ka kii",
    verificationResent: "Kumpabo imeeloo murungta kii benta",
    verificationResendFailed: "Kumpabo imeeloo murungta kii mang ben. I si a ñining tugung.",
    usernameInvalidChars: 'Toh-kilaa teema sifarolu, kontolu, doot (dots) ani layi dorong faata',
    networkError: 'Netwook filiya. I la kumpabo kandaa ani ñining tugung.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Toh-kilaa',
    password: 'Paswoodoo',
    loginButton: 'Long in',
    or: 'wala',
    savedAccounts: 'Akaantolu marata',
    loginSuccess: 'Long in benta',
    loginError: 'Long in mang ben. I la long-kumol kumpabo.',
    googleLogin: 'Taa noma Google la',
    facebookLogin: 'Taa noma Facebook la',
    rememberMe: 'N hakili too',
    forgotPassword: 'I nyinata paswoodoo to?',
    noAccount: 'I ti akaanti soto?',
    createAccount: 'Akaanti dada',
    registerNow: "Akaanti dada saaying",
    termsAndPolicy: 'Long in to, i sota nna Baara Saratol ani Sutura Lataramoo to',
    loggingIn: "A ka long in...",
    fieldsRequired: "Toh-kilaa ani paswoodoo lafiya-le",
    invalidCredentials: "Toh-kilaa wala paswoodoo mang ben",
    tooManyAttempts: "Long in ñiningo tiyama tambita. I si a ñining nooma-nooma.",
    loginFailed: "Long in mang ben. I si a ñining tugung.",
    oauthNotImplemented: "Social long in mang dada folo",
    savedLoginNotImplemented: "Akaanti mara long in mang dada folo"
  },
  charts: {
    tooltip: {
      title: 'Lung',
      totalQueries: 'Ñiningol bee kafung',
      uniqueUsers: 'Moolu Kiling-kiling'
    },
    day: 'Lung',
    noData: 'Kibaro te',
    notAvailable: 'Te faa (N/A)',
    topQueries: 'Ñiningo santo',
    categoryDistribution: 'Longo dulaa baara-coko',
    usageTrend: 'Baara-coko dulaa'
  },
  analytics: {
    title: 'Kibaro Lataramoo (Analytics)',
    loading: 'Kibaro ka looti...',
    period: 'Waatoo',
    charts: {
      satisfactionHeatmap: "Hali longo dulaa",
      satisfactionSubtitle: "Hali waatoo santo (kilo-coko)"
    },
    timePeriods: {
      week4: "Lokung 4 tambita",
      week3: "Lokung 3 tambita",
      week2: "Lokung 2 tambita",
      week1: "Lokung tambita",
      current: "Saaying"
    },
    errors: {
      loading: "Hali kibaro lootay mang ben. I si a ñining tugung.",
    },
    status: {
      loading: 'A ka looti...',
      noData: 'Kibaro te nying waatoo ye',
      error: 'Filiyata kibaro looti to',
      online: "Sistemoo yeleta",
      offline: "Sistemoo dadeta",
      responseTime: "Jaabi-waatoo teema",
      queueLength: "Kilaa lo-da",
      uptime: "Baara-waatoo"
    },
    periods: {
      daily: 'Lung-o-lung',
      weekly: 'Lokung-o-lokung',
      monthly: 'Kalo-kalo',
      allTime: 'Waatoo bee'
    },
    metrics: {
      totalQueries: 'Ñiningol bee',
      uniqueUsers: 'Moolu Kiling-kiling',
      avgResponseTime: 'Jaabi-waatoo teema',
      satisfaction: 'Moolu Hali'
    },
    table: {
      rank: 'Jaayi',
      query: 'Ñiningo',
      count: 'Konto',
      avgTime: 'Waatoo teema'
    },
    chartLabels: {
      categories: 'Dulaalu',
      serviceCategories: 'Longo Dulaalu',
      byUsage: 'Baara coko-ye',
      category: 'Dulaa'
    },
    tooltips: {
      selectPeriod: 'Waatoo ceng',
      selectDate: 'Lung ceng',
      exportData: 'Kibaro kii banta'
    },
    gauge: {
      historical: 'Koto-tariiki',
      vsPrevious: 'tambi-waatoo la',
      target: 'Taa-da'
    },
    ratings: {
      poor: "A dooyata baa",
      average: "A benta-teema",
      good: "A benta",
      excellent: "A bambangta baa"
    },
    slower: 'a dooyata',
    faster: 'a jooyata',
    percentage: 'Kilo-coko',
    note: 'Nying duuma mu baara coko ani moolu kumol ti.',
    usageStats: 'Baara Cokoolu',
    peakUsers: 'Moolu kuntii',
    activeChats: 'Kuma baarakilaa',
    usageTrend: 'Baara-coko',
    topQueries: 'Ñiningo santo',
    feedbackSamples: 'Moolu jaabari',
    close: 'A dade',
    chartComingSoon: 'Caat yitandi ka naata joona...',
    retry: 'Ñining tugung',
    dailyQueries: 'Lung-o-lung Ñiningol',
    export: 'Kibaro kii banta',
    dateRange: 'Lung waatoo',
    startDate: 'Damina Lung',
    endDate: 'Labang Lung',
    rank: 'Jaayi',
    query: 'Ñiningo',
    count: 'Konto',
    avgTime: 'Waatoo teema',
    serviceUsage: 'Longo Dulaa Baara-coko',
    usageTrends: 'Baara-coko',
    week: 'Lokung labang',
    month: 'Kalo labang',
    quarter: 'Karo sabajang labang',
    year: 'Sanji labang',
    uniqueUsers: 'Moolu Kiling-kiling',
    satisfactionRate: 'Hali-coko',
    satisfactionAnalysis: 'Moolu Hali Kibaroo'
  },
  brandName: 'Genie AI: I la Gomnati Baaralaa',
  nav: {
    systemStatus: 'Sistemoo Cokoyaa',
    menu: 'Katifol',
    analytics: 'Kibaro Lataramoo',
    userProfile: 'Moo-kibaroo',
    settings: 'Setinsi (Kilaatol)',
    logout: 'Bong banta',
    profile: 'Nna Moo-kibaroo',
    toggleSidebar: 'Bulu-mang-kuma yailama',
    changeLanguage: 'Kangoo yailama',
    administration: "Adiministireson (Gomnati)",
    languages: {
      english: 'Angalee-kang',
      french: 'Faraansi-kang',
      swahili: 'Sawali-kang'
    }
  },
  systemStatus: {
    title: 'Baaralaa Cokoyaa',
    services: 'Baaralu',
    operational: 'A ka baara',
    degraded: 'A dooyata-le',
    outage: 'A fitiyata',
    allOperational: 'Sistemol bee',
    someIssues: 'Kuraa doolu',
    majorIssues: 'Kuraa baalu',
    checking: 'A ka kumpabo...',
    nextDeadline: 'Waatoo tambi-da nooma',
    days: 'tilungol',
    viewDetails: 'Kibarol bee je'
  },
  services: {
    eCitizen: 'e-Jamo Portal',
    taxFiling: 'Jooyaa Lataramoo',
    idApplication: 'ID Ñiningo',
    businessReg: 'Bita Lataramoo',
    drivingLicense: 'Moto Bula-Laisins'
  },
  deadlines: {
    taxFiling: 'Jooyaa Tambi-da',
    businessRenewal: 'Bita Laisins Kurandi',
    idRenewal: 'ID Kaard Kurandi',
    vehicleRegistration: 'Moto Lataramoo Tambi-da'
  },
  sidebar: {
    governmentServices: 'Longo Dulaalu',
    chatHistory: 'Kuma Koto',
    searchPlaceholder: 'Longo dulaalu ñining...',
    createFolder: 'Folda Dada',
    editFolder: 'Folda Dada',
    folderName: 'Folda Toh',
    folderNamePlaceholder: 'Folda toh nyining',
    moveChat: 'Kuma Tita',
    moveChatTo: 'Kuma Tita jang',
    selectFolder: 'Folda Ceng',
    deleteChat: 'Kuma Fiti',
    deleteChatConfirm: 'I lafiya la ka nying kuma fiti le ti?',
    deleteChatWarning: 'Nying kwoo mang si murung.',
    renameChat: "Kuma Toh Yailama",
    chatTitle: "Kuma Toh",
    chatTitlePlaceholder: "Kuma toh kura nyining",
    deleteFolder: "Folda Fiti",
    deleteFolderConfirm: "I lafiya la ka '{name}' folda fiti le ti?",
    chatsMoveWarning: "Nying folda kono kumal bee si tita folda-ceng-to.",
    weatherError: "Sanoo kibaroo lootay mang ben. I si a ñining tugung.",
    weatherTitle: 'Sanoo Kibaroo',
    weatherLoading: 'Sanoo kibaro ka looti...',
    weatherLocationLoading: 'Dulaa ka looti...',
    weatherErrorDefault: 'Sanoo kibaroo ñiningo mang ben.',
    weatherGeolocationUnsupported: 'Browser ti nying dulaa kumpabo faa.',
    weatherRefresh: 'Sanoo Kurandi',
    weatherConditions: {
      clear: 'A keta-le (Clear)',
      partlycloudy: 'Tubalo doo (Partly Cloudy)',
      cloudy: 'Tubalo (Cloudy)',
      overcast: 'Tilo mutata (Overcast)',
      rain: 'Sanji',
      shower: 'Sanji-doo (Shower)',
      thunderstorm: 'Sanji kili/Mandi-mandi (Thunderstorm)',
      snow: 'Nyengoo (Snow)'
    },
    folders: "Foldalu",
    emptyFolder: "Nying folda lankoto. Kuma tita jang kuma menu to.",
    title: 'Kibaro ani Dulaalu',
    noChats: 'Kuma kura mang je',
    relatedDocs: 'Dokuuma kafo',
    noDocuments: 'Dokuuma kafo mang je',
    faq: 'Ñiningo Ka Ke-yaa',
    tab: {
      all: 'Kumal bee',
      folders: 'Foldalu',
      starred: 'Lotoolu marata',
      archived: 'Lotorolu (Archived)'
    },
    savedChats: 'Kumal marata',
    chats: "Kumal",
    allChats: "Kumal bee",
    noFolder: "Folda mang je",
    starredChats: "Kumal Lotoota",
    archivedChats: "Kumal Lotorota",
    noStarredChats: "Kumal lotoota mang je. Kuma lotoo ka a kafu jang.",
    noArchivedChats: "Kumal lotorota mang je.",
    noSearchResults: 'Kuma mang je "{term}" ye',
    loadingChats: "Kumal ka looti...",
    errorLoadingConversations: "Filiyata kumal looti to. I si a ñining tugung.",
    errorLoadingUser: "Moo kibaro ti faa. Browser murung.",
    errorNoUser: "Moo kibaro mang je. Browser murung.",
    retry: "Ñining tugung",
    message: "kilaa",
    messages: "kilaalu",
    created: "Dadata",
    updated: "Yailamata",
    star: "Lotoo (Star)",
    unstar: "Lotoo Fiti",
    archive: "Lotoro (Archive)",
    chatStarred: "Kuma lotoota benta",
    chatUnstarred: "Kuma lotoo fitita benta",
    chatArchived: "Kuma lotorota benta",
    chatUnarchived: "Kuma lotoro botata benta",
    errorUpdatingChat: "Filiyata kuma yailama to",
    chatRenamed: "Kuma toh yailamata benta",
    errorRenamingChat: "Filiyata kuma toh yailama to",
    chatDeleted: "Kuma fitita benta",
    errorDeletingChat: "Filiyata kuma fiti to",
    chatMoved: "Kuma titata benta",
    errorMovingChat: "Filiyata kuma tita to",
    noPreview: "Luka-folo mang je",
    searchConversations: 'Kumal ñining...',
    selectFolderInstruction: "Folda ceng ka kumal je",
    folderCreated: "Folda dadata benta",
    errorCreatingFolder: "Filiyata folda dada to",
    errorLoadingFolders: "Filiyata folda looti to",
    folderUpdated: "Folda yailamata benta",
    errorUpdatingFolder: "Filiyata folda yailama to",
    folderDeleted: "Folda fitita benta",
    errorDeletingFolder: "Filiyata folda fiti to",
    chatRemovedFromFolders: "Kuma botata folda to",
    errorRemovingChat: "Filiyata kuma bota folda to",
    id: 'ID',
    labels: 'Mata-kumol',
    confidence: 'Kumpa-koyiyaa',
    unknown: 'Long-mang-long'
  },
  leftPanel: {
    cat1: {
      name: '1. Jamo ani Moo Lataramoo',
      children: ['Bulu-lung dokuumalu', 'ID kaardolu', 'Pasport', 'Furung ani Saaya dokuumalu', 'Vote-moo lataramoo']
    },
    cat2: {
      name: '2. Kenda-yaa ani Jamaa Baaralu',
      children: ['Pablik kenda-yaa dulaalu', 'Dokotoro dulaalu', 'Kenda-yaa insooransi', 'Seng-moo la baaralu', 'Moolu dulaa ani nimal']
    },
    cat3: {
      name: '3. Karandiri ani Longo',
      children: ['Pablik sukuul ani unibersiti', 'Karandiri jooyaa', 'Moo-baa karandiri', 'Onlayin karandiri dulaalu']
    },
    cat4: {
      name: '4. Baara ani Cee-baara Lataramoo',
      children: ['Baara ñining ani baara-balaa hako', 'Baarakilaa kantari', 'Baara dulaa kantari', 'Karandiri-doo (Skills)']
    },
    cat5: {
      name: '5. Jooyaa (Taxes) ani Kodo',
      children: ['Jooyaa muta ani murung', 'Dulaa jooyaa', 'Bita jooyaa', 'Kastom ani julo jooyaa']
    },
    cat6: {
      name: '6. Jamo Kantari ani Kiti-yaa',
      children: ['Polisi ani tura-kandaa baaralu', 'Kiti-yaa ani lawu baaralu', 'Kiti-moo kili', 'Moo-kantari lawu']
    },
    cat7: {
      name: '7. Taa-ani-Naa ani Moto',
      children: ["Moto Bula-Laisins ani lataramoo", 'Jamo moto ani silalu', 'Sila-kiti ani kiti-jooyaa', 'Sila-kantari baaralu']
    },
    cat8: {
      name: '8. Dulaa ani Suw-Lataramoo',
      children: ['Jamo dulaa baara', 'Suw lataramoo ani dokuumalu', 'Suw kodo-sing ani loo-hako', 'Suw loo permol']
    },
    cat9: {
      name: '9. Dulaa-baara ani Dulaa-Kenda-yaa (Environment)',
      children: ['Jiyo ani elektrik baaralu', 'Nonsiyo maralaa', 'Dulaa-kantari lawu', 'Kura-kura elektiriki']
    },
    cat10: {
      name: '10. Bita ani Jula-yaa',
      children: ['Bita lataramoo ani laisins', 'Jula-yaa lawu ani permol', 'Bita-doo kodo', 'E-komaas ani bita intanet']
    },
    cat11: {
      name: '11. Pensol ani Moolu Kantari',
      children: ['Baara-bula kodo', 'Pensol kodo lataramoo', 'Dimba-kodo', 'Seng-moo pensol']
    },
    cat12: {
      name: '12. Jamo-Baara ani Vote',
      children: ['Vote ani bota-moo', 'Jamo lauma ani kiti', 'Moo-dimba baara', 'Jamo lataramoo baara']
    }
  },
  settings: {
    title: 'Setinsi (Kilaatol)',
    save: 'A mara',
    close: 'A dade',
    saveSettings: 'Setinsi mara',
    savingSettings: "I la setinsi ka mara...",
    settingsSaved: "Setinsi marata benta!",
    saveSuccess: 'Setinsi marata benta',
    saveError: 'Filiyata setinsi mara to',
    display: 'Yitandili',
    displayLanguage: 'Yitandili Kangoo',
    languages: {
      english: 'Angalee-kang',
      french: 'Faraansi-kang',
      swahili: 'Sawali-kang'
    },
    theme: 'Cokoyaa-Teema (Theme)',
    themes: {
      light: 'Koyoo (Light)',
      dark: 'Diboo (Dark)',
      system: 'Sistemoo'
    },
    fontSize: 'Sifar warayaa',
    notifications: 'Kibarolu',
    emailUpdates: 'Imeeloo kibarolu',
    soundNotifications: 'Kuma kibarolu',
    accountManagement: 'Akaanti Lataramoo',
    emailAddress: 'Imeeloo dulaa',
    emailAddressPlaceholder: 'I la imeeloo dulaa',
    password: 'Paswoodoo',
    changePassword: 'Paswoodoo yailama',
    resetUserData: 'Moo Kibaroo Fitindi',
    resetUserDataDesc: 'Nying si i la moo-kibaroo bee fiti ani kuma koto.',
    deleteAccount: 'Akaanti Fiti',
    deleteAccountDesc: 'Nying si i la akaanti fiti abada ani a kibaro bee.',
    edit: 'A dada',
    standardAccount: 'Akaanti Kilingo',
    confirmEmailChange: 'Imeeloo Yailama Kumpabo',
    pleaseEnterPassword: 'Ibay dii i la paswoodoo to',
    cancel: 'A bula',
    account: {
      title: 'Akaanti',
      resetDescription: 'Nying si i la moo-kibaroo bee fiti ani kuma koto.',
      confirmReset: 'I lafiya la ka kibaro bee fiti le ti? Nying kwoo mang si murung.',
      resetComplete: 'I la kibaroo fitita.'
    },
    language: {
      title: 'Kangoo',
      selectLabel: 'Yitandili Kangoo'
    },
    appearance: {
      title: 'Nyaka (Appearance)',
      lightTheme: 'Koyoo',
      darkTheme: 'Diboo',
      systemTheme: 'Sistemoo'
    },
    confirmDeleteAccount: 'I lafiya la ka i la akaanti fiti le ti? Nying kwoo mang si murung.',
    confirmAccountDeletion: 'Akaanti Fiti Kumpabo',
    accountDeletionWarning: 'Kankutay: Nying kwoo mu abada le ti ani a mang si murung. I la kibaroo bee si fiti abada.',
    deletionReason: 'Hako ka fiti (mang-kandi):',
    deletionReasonPlaceholder: 'Munne y\'a tinna i lafiya ka i la akaanti fiti?',
    enterPasswordConfirm: 'I la paswoodoo dii ka kumpabo:',
    currentPasswordPlaceholder: 'I la paswoodoo saaying',
    deleting: 'A ka fiti...',
    permanentlyDeleteAccount: 'Akaanti Fiti Abada',
    accountDeletedSuccess: 'I la akaanti fitita benta.',
    incorrectPassword: 'Paswoodoo mang ben',
    accountDeletionFailed: 'Akaanti fiti mang ben. I si a ñining tugung.',
    confirmChange: 'Yailama Kumpabo',
    processing: 'A ka baara...',
    userDataReset: 'I la moo-kibaroo fitita benta.',
    failedToResetUserData: 'Moo-kibaroo fiti mang ben. I si a ñining tugung.',
    changingEmailTo: 'I la imeeloo ka yailama ka taa',
    will: 'si',
    logOutSystem: 'I bong banta sistemoo to',
    sendVerificationLink: 'Kumpabo linkoo kii i la imeeloo kura to',
    requireVerification: 'Kumpabo kura ñining folo i ye long in tugung',
    checkNewEmailVerification: 'I la imeeloo kura kumpabo kumpabo kililaalu ye.',
    unableToVerifyEmail: 'Imeeloo kumpabo mang ben. I si a ñining tugung.',
    emailAlreadyInUse: 'Imeeloo ka baara saaying',
    enterValidEmail: 'Ibay dii imeeloo ceng-ceng',
    failedToUpdateEmail: 'Imeeloo yailama mang ben. I si a ñining tugung.',
    passwordResetInitiated: 'Paswoodoo kurandi linkoo kiyata i la imeeloo to.',
    unableToLoadUser: 'Moo kibaro looti mang ben. I si a ñining tugung.',
    retry: 'Ñining tugung',
    user: 'Moo',
    loadingUserInfo: 'Moo kibaro ka looti...',
    resetUserDataTitle: "Moo Kibaroo Fitindi",
    confirmResetUserData: "I lafiya la ka i la moo-kibaroo bee fitindi le ti? Nying si i la kibaro bee fiti ani kuma koto, kani i la akaanti dung-kumol si tu yeng.",
    reset: "Kurandi (Reset)",
    deleteAccountTitle: "Akaanti Fiti"
  },
  userProfile: {
    title: 'Moo-kibaroo',
    privacyInfo: "Ning i ye kibaro faa dii, i si jaabi faa ani beteyaa soto chatboto la. Ibay dii a kumpabo nna",
    privacyPolicyLink: 'Sutura Lataramoo',
    tabComingSoon: 'Nying nyiningo ka dada folo ani a naata joona.',
    saveSuccess: 'Moo-kibaroo marata benta',
    loadError: 'Filiyata moo-kibaroo looti to',
    saveError: 'Filiyata moo-kibaroo mara to',
    confirmSaveTitle: "Moo-kibaroo Mara",
    confirmSave: "I lafiya la ka nying yailamawol mara le ti?",
    confirmCancel: 'I la yailamawol ti mara folo. I lafiya la a bula le ti?',
    confirmLeave: 'I lafiya la ka taa le ti? Yailamawol bee min ti mara si fiti.',
    confirmDiscardChanges: 'Yailamawol mang mara bula?',
    uploadPhoto: 'Foto Yele',
    uploadFile: 'Fayiloo Yele',
    photoRequirements: 'Foto nanta ka koya, saaying-saaying yela, ani a nanta ka i daa faata yitandi',
    biometricRequirements: 'Biometrik fayilolu kiling faata le jeta',
    documentUpload: 'Dokuuma Yele',
    validationTitle: 'Ibay dii filiya nyolu dada:',
    profileIcon: 'Moo-kibaroo Nyako',
    change: 'A yailama',
    chooseProfileIcon: 'Moo-kibaroo Nyako Ceng',
    presetIcons: 'Nyako marata',
    upload: 'Yele',
    initials: 'Toh-fata (Initials)',
    clickToUpload: 'Yele jang',
    useThisImage: 'Nying foto baara',
    useInitials: 'Toh-fata baara',
    tabs: {
      tab1: 'Moo Kiling-kiling Kibaro',
      tab2: 'Jamo Lataramoo ani Dokuumalu',
      tab3: 'Dulaa ani Suw Kibaroo',
      tab4: 'Jamo ani Taa-ani-Naa Dokuumalu',
      tab5: 'Kenda-yaa ani Dokotoro Kibaroo',
      tab6: 'Baara ani Kodo Kibaroo',
      tab7: 'Karandiri ani Sukuul Kibaroo',
      tab8: 'Kodo ani Jooyaa Kibaroo',
      tab9: 'Moolu Kantari ani Kodo',
      tab10: 'Kiti-yaa ani Lawu Kibaroo',
      tab11: 'Moto ani Sila Kibaroo',
      tab12: 'Jamo ani Vote Kibaroo'
    },
    actions: {
      cancel: 'A bula',
      save: 'Moo-kibaroo Mara',
      previous: 'A koto',
      next: 'A noomata',
      saving: 'A ka mara...'
    },
    fields: {
      fullName: 'Toh faata (ani toh-do-do)',
      dob: 'Bulu-lung',
      gender: 'Kee / Muso (Gender)',
      nationality: 'Bankoo/Jamoo (Nationality)',
      maritalStatus: 'Furu-coko',
      photograph: 'Foto',
      biometric: 'Bulu-noo / Biometrik',
      birthCert: 'Bulu-lung dokuuma',
      deathCert: 'Saaya dokuuma',
      marriageDivorce: 'Furung / Furung-bula dokuuma',
      adoption: 'Dinging-mutalay dokuuma',
      citizenship: 'Jamoo dokuuma',
      immigration: 'Taa-ani-Naa ani visa',
      currentAddress: 'Suw dulaa saaying',
      previousAddresses: 'Suw dulaa kotoolu',
      postalCode: 'Positi kodo',
      country: 'Bankoo',
      residencyStatus: 'Suw-coko',
      homeOrRental: 'Suw-tii wala Loo',
      utilityBills: 'Jiyo/Elektiriki jooyaa (dulaa)',
      landRecords: 'Banko ani suw-tii dokuumalu',
      idCard: 'Jamo ID kodo',
      passport: 'Pasport kodo',
      driversLicense: "Moto Bula-Laisins",
      voterId: 'Vote ID',
      ssn: 'Moolu Kantari Kodo',
      militaryRecords: 'Soojaa baara dokuumalu',
      medicalHistory: 'Kenda-yaa ani kuraa dokuumalu',
      vaccinations: 'Batoo-kurandi (Vaccination) dokuumalu',
      insuranceDetails: 'Kenda-yaa insooransi',
      disability: 'Seng-moo coko',
      bloodType: 'Jiyo suko (Blood Type)',
      organDonor: 'Fari-tii diilaa',
      prescriptions: 'Basi dokuumalu',
      mentalHealth: 'Hakili-kenda-yaa',
      eHistory: 'Baara tariiki',
      currentEmployer: 'Baara-tii saaying',
      workPermits: 'Baara permol ani sotiya',
      certifications: 'Baara dokuumalu ani laisins',
      unemployment: 'Baara-te coko ani kodo diilaa',
      tin: 'Jooyaa diilaa kodo (TIN)',
      businessAffiliations: 'Bita-tii ani kampani',
      schools: 'Sukuul ani unibersiti',
      education: 'Karandiri',
      degrees: 'Diplomalu, degril ani dokuumalu',
      performance: 'Karandiri ñiningo ani maka',
      academicRecords: "Sukuul Dokuumalu",
      scholarships: 'Karandiri jooyaa (scholarship)',
      incomeTax: 'Kodo jooyaa dokuumalu',
      bankAccounts: 'Banko ani kodo',
      propertyTax: 'Suw jooyaa',
      businessTax: 'Bita jooyaa',
      pensionContrib: 'Pensol kodo',
      loanAid: 'Sing-kodo ani gomnati kodo',
      pensionStatus: 'Pensol coko',
      childcare: 'Dinging kantari',
      foodAssistance: 'Daa-kodo / gomnati baara',
      housingAssistance: 'Suw kodo baara',
      policeRecords: 'Polisi dokuumalu',
      courtCases: 'Kiti-yaa dokuumalu',
      finesPenalties: 'Kiti-jooyaa',
      paroleProbation: 'Kaso-bota coko',
      citizenshipRevocation: 'Jamo-bota dokuuma',
      vehicleReg: 'Moto lataramoo',
      trafficViolations: 'Sila-kiti ani kiti-jooyaa',
      licenseHistory: 'Moto laisins dokuuma',
      publicTransportCard: 'Pablik moto kaard',
      voterRegistration: 'Vote-moo lataramoo',
      electionHistory: 'Vote-moo dokuuma',
      partyMembership: 'Politiki kilingo',
      militaryStatus: 'Soojaa baara',
      publicServiceRoles: 'Jamo-baara tiyaa'
    },
    placeholders: {
      fullName: 'I la toh faata nyining',
      nationality: 'I la bankoo nyining',
      searchCountries: 'Bankoolu ñining...',
      selectCountry: 'Bankoo ceng',
      searchDisciplines: "Baara-fata ñining...",
      selectDiscipline: "Baara-fata ceng",
      searchDegrees: "Degril ñining...",
      selectDegree: "Degri ceng"
    },
    validation: {
      nameRequired: 'Toh faata lafiya-le',
      dobRequired: 'Bulu-lung lafiya-le',
      dobFuture: 'Bulu-lung mang si ke waatoo naa-too',
      requiredField: '{field} lafiya-le',
      invalidFormat: '{field} mang ben',
      futureDate: 'Lung mang si ke waatoo naa-too',
      invalidSelection: 'Ibay dii ceng ben-ndi',
      passwordLength: 'Paswoodoo nanta ka ke sifar 8',
      matchError: 'Nyolu mang ben'
    },
    errors: {
      savingFailed: 'Moo-kibaroo mara mang ben',
      loadingFailed: 'Moo-kibaroo looti mang ben',
      invalidForm: 'Ibay dii kibaro bee faa',
      invalidFileType: 'Fayil suko mang ben',
      fileTooLarge: 'Fayiloo warata baa',
      countryLoadError: 'Bankoolu looti mang ben',
      countryUpdateError: 'Bankoo yailama mang ben'
    },
    notifications: {
      saveSuccess: 'Moo-kibaroo marata benta',
      saveFailed: 'Moo-kibaroo mara mang ben',
      loadSuccess: 'Moo-kibaroo lootita benta',
      loadFailed: 'Moo-kibaroo looti mang ben',
      fieldRequired: 'Nying dulaa lafiya-le',
      uploadSuccess: 'Fayiloo yeleta benta',
      uploadFailed: 'Fayiloo yele mang ben',
      formChanged: 'I la yailamawol ti mara folo',
      sessionExpired: 'I la waatoo tambita, i si long in tugung',
      profileUpdated: 'I la moo-kibaroo yailamata benta',
      profileIncomplete: 'I la moo-kibaroo ti faa'
    },
    instructions: {
      fullNameHelp: 'I la toh faata nyining ko a be i la dokuuma to coko min',
      dobHelp: 'I la bulu-lung nyining MM/DD/YYYY to',
      uploadPhotoHelp: 'Foto saaying-saaying yela. Fayiloo nanta ka ke JPG, PNG, wala GIF ani a nanta ka dooyata 2MB to',
      passwordHelp: 'Paswoodoo nanta ka ke sifar 8, a ning sifar-baa 1, konto 1, ani sifar-suko 1',
      documentHelp: 'Fayilolu sota: PDF, JPG, PNG (tambi-da 5MB)',
      requiredFields: 'Dulaalu mata * lafiya-le',
      selectFromList: 'Ibay dii ceng kafo kono',
      nextTab: 'Taa dulaa kura to',
      previousTab: 'Murung dulaa koto to',
      saveInstructions: 'A mara piki ka i la kibaroo mara',
      cancelInstructions: 'A bula piki ka yailamawol fiti'
    },
    completionStatus: {
      notStarted: 'Ti damina',
      inProgress: 'A ka baara',
      complete: 'A faata',
      percentComplete: '{percent}% faata',
      tabsCompleted: '{completed} to {total} dulaalu faata',
      tabComplete: 'Dulaa faata!'
    },
    gender: {
      male: 'Kee',
      female: 'Muso',
      other: 'Doo',
      preferNot: 'N ti lafiya k\'a fo'
    },
    maritalStatus: {
      single: 'Muso/Kee ti muta (Singiri)',
      married: 'Furu-moo',
      divorced: 'Furung-botata',
      widowed: 'Furung-moo sata',
      other: 'Doo'
    },
    residencyStatuses: {
      citizen: 'Jamo-tii',
      permanentResident: 'Jamo-tii-daa (Permanent)',
      temporaryResident: 'Jamo-moo-saa',
      other: 'Doo'
    },
    employmentStatuses: {
      employed: 'Baarakilaa',
      selfEmployed: 'I la baara-tii',
      unemployed: 'Baara-te',
      student: 'Karandiri-dingo',
      retired: 'Baara-bula (Retire)',
      homemaker: 'Suw-tii (Homemaker)',
      other: 'Doo'
    },
    educationLevels: {
      primary: 'Karandiri damina (Primary)',
      secondary: 'Sukuul-teema (Secondary)',
      highSchool: 'Sukuul-baa (High School)',
      vocational: 'Baara karandiri',
      associate: 'Diplom (Associate)',
      bachelor: 'Digri folo (Bachelor)',
      master: 'Digri-teema (Master)',
      doctoral: 'Digri-baa (Doctoral)',
      professional: 'Digri-baara (Professional)',
      other: 'Doo'
    },
    proficiencyLevels: {
      native: 'Jamoo-kang',
      fluent: 'Kang-koya',
      advanced: 'A beteyata',
      intermediate: 'A teema',
      basic: 'A damina'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Long-mang-long'
    },
    languages: {
      english: 'Angalee-kang',
      french: 'Faraansi-kang',
      swahili: 'Sawali-kang',
      arabic: 'Araboo-kang',
      spanish: 'Sipanis-kang',
      portuguese: 'Portugesi-kang',
      chinese: 'Ciniisi-kang',
      japanese: 'Japanesi-kang',
      german: 'Jaman-kang',
      russian: 'Rusiyan-kang',
      hindi: 'Hindi-kang',
      urdu: 'Urdu-kang',
      other: 'Doo'
    },
    yesNo: {
      yes: 'Haa',
      no: 'Hani'
    },
    select: 'Ibay dii ceng',
    existingFile: 'Fayiloo saaying',
    noMatchingCountries: 'Bankoo mang ben',
    noMatchingDisciplines: "Baara-fata mang ben",
    noMatchingDegrees: "Degri mang ben",
    educationOptions: [
      "Accounting (Kodo lataramoo)", "Aerospace (Kulong-santo baara)", "Sene baaralu", "Moo-longo (Anthropology)", "Loo baaralu",
      "Foto tariiki", "AI", "Salo longoo", "Salo-koo longoo", "Biochemistry",
      "Kenda-yaa Enginering", "Biyo-baara", "Bita Lataramoo", "Kimikal Enginering",
      "Kimikal longoo", "Suw Enginering", "Kuma-longo", "Kompuuta Enginering", "Kompuuta longoo",
      "Loo lataramoo", "Kiti-yaa longoo", "Kompuuta kantari", "Data longoo", "Nyin longoo",
      "Kodo-longoo", "Karandiri", "Elektrik Enginering", "Sukuul-ding karandiri", "Angalee karandiri",
      "Dulaa-kenda-yaa Enginering", "Dulaa-kenda-yaa longoo", "Dondiko dada", "Film longoo",
      "Kodo (Finance)", "Fayn Arts", "Daa-longoo", "Polisi longoo", "Geym dada", "Geografi",
      "Banko longoo", "Grafik dada", "Kenda-yaa lataramoo", "Tariiki", "Makaamoo lataramoo",
      "Moo baara", "Fengo dada", "Sati-baa Enginering", "Kibaro lataramoo",
      "Longo baara (IT)", "Suw-kono dada", "Banko-teema bita", "Banko-teema kuma",
      "Kibaro-folaa", "Lawu", "Buku longoo", "Kang-longoo", "Lataramoo", "Jula-yaa (Marketing)",
      "Murumuru longoo", "Matematiki", "Makin Enginering", "Media longoo", "Dokotoro",
      "Sanoo longoo", "Mikro-longoo", "Muzik", "Nanolongo", "Nasi baara", "Baloo longoo",
      "Kenda-yaa baara", "Baa-longoo", "Jiyo Enginering", "Farmasi (Basi)", "Filosofi",
      "Foto-mutalaa", "Fari kenda-yaa", "Fari kenda-yaa baara", "Fisiks", "Politiki longoo",
      "Hakili longoo", "Jamo Lataramoo", "Jamo kenda-yaa", "Jamo kuma", "Robootik",
      "Sukuul-teema karandiri", "Moo baara", "Sosioloji", "Softweya Enginering", "Karandiri-doo",
      "Tolong lataramoo", "Statistika", "Sistem Enginering", "Sinima baara", "Taa-ani-Naa baara",
      "Sati lataramoo", "Bisi Dokotoro", "Web dada", "Wulo-sugo longoo", "Sugo longoo"
    ],
    degreeOptions: [
      "Associate Degri", "Bachelor of Arts (BA)", "Bachelor of Science (BS)", "Bachelor of Engineering (BEng)",
      "Bachelor of Business Administration (BBA)", "Bachelor of Fine Arts (BFA)", "Bachelor of Education (BEd)",
      "Bachelor of Medicine (MBBS)", "Bachelor of Laws (LLB)", "Master of Arts (MA)", "Master of Science (MS)",
      "Master of Business Administration (MBA)", "Master of Engineering (MEng)", "Master of Fine Arts (MFA)",
      "Master of Education (MEd)", "Master of Laws (LLM)", "Master of Public Health (MPH)",
      "Doctor of Philosophy (PhD)", "Doctor of Medicine (MD)", "Doctor of Education (EdD)",
      "Doctor of Business Administration (DBA)", "Doctor of Jurisprudence (JD)", "Professional Diplom",
      "Teknikal Diplom", "Vokesonal Diplom", "Graduate Diplom", "Post-Graduate Diplom", "Post-Doctoral"
    ],
    aria: {
      tabList: 'Moo-kibaroo fata-fata',
      nextButton: 'Taa dulaa kura to',
      prevButton: 'Taa dulaa koto to',
      closeButton: 'Moo-kibaroo dade',
      saveButton: 'Moo-kibaroo mara',
      requiredField: 'Lafiya-le',
      dropdownSelect: 'Ceng'
    }
  },
  chatbot: {
    placeholder: 'I la ñiningo nyining jang...',
    sendButton: 'Kii',
    fileReceived: 'Fayiloo yeleta benta.',
    fileUploadError: 'Filiyata fayiloo yele to.',
    processingError: 'Filiyata i la ñiningo dada to.',
    welcomeMessage: 'Bismillay! Mbe ñaadi ka i makaamoo ning Keniya gomnati baaralu bii?',
    attachFile: 'Fayiloo Kafu',
    fileTooLarge: 'Fayiloo warata baa. Tambi-da mu {maxSize} ti.',
    saveChat: 'Kuma Mara',
    chatSaved: 'Kuma Marata',
    chatTitle: 'Kuma Toh',
    chatTitlePlaceholder: 'Kuma toh nyining',
    selectFolder: 'Folda Ceng',
    newChat: 'Kuma Kura',
    clearContext: 'Kuma fiti ani kuma kura damina',
    unsavedChanges: 'I la yailamawol ti mara. I lafiya la ka kuma kura damina le ti?',
    whatCanIHelp: "Mbe ñaadi ka i makaamoo bii?",
    justChat: "Kuma Dorong",
    queryContext: "Ñiningo Coko",
    contextAdded: 'Cokoyaa kafuta i la ñiningo to',
    contextRemoved: 'Cokoyaa botata i la ñiningo to',
    sessionUpdated: 'Waatoo yailamata',
    newChatStarted: 'Kuma kura daminata',
    loadError: 'Filiyata kuma koto looti to',
    responsePrefix: "N sota i la kilaa ye",
    withContext: "ning cokoyaa",
    conversationLoaded: "Kumal lootita benta!",
    saveConfirmTitle: "Kuma Mara saaying",
    saveConfirmMessage: "Kuma mara saaying?",
    loadConfirmTitle: "Kuma Koto Looti",
    loadConfirmMessage: "I la yailamawol ti mara. I lafiya la ka yailamawol fiti ani kuma koto looti le ti, wala ka kuma saaying mara folo?",
    loadAndDiscard: "Looti ani Fiti",
    saveAndLoad: "Mara ani Looti",
    saveAndStartNew: "Mara ani Damina Kura",
    discardAndStartNew: "Fiti ani Damina Kura",
    newChatTitle: "Kuma Kura Damina",
    exportChat: 'Kuma Kii Banta',
    exportFilename: 'Fayil Toh',
    exportFilenamePlaceholder: 'Fayil toh nyining',
    exportButton: 'Kii banta',
    exportSuccess: 'Kuma kiyata banta benta',
    exportError: 'Filiyata kuma kii to. I si a ñining tugung.'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "ID Ñiningo",
    payTaxes: "Jooyaa muta",
    startBusiness: "Bita damina",
    findHealthcare: "Kenda-yaa",
    educationServices: "Karandiri",
    transportLicenses: "Moto",
    housingPrograms: "Suw",
    findJobs: "Baara",
    justChat: "Kuma Dorong",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "N lafiya la ka kuma gomnati baaralu kang",
    applyForIDUserPrompt: "N lafiya la ka long ñaadi mbe ID kaard ñiningo ke",
    payTaxesUserPrompt: "Jooyaa muta onlayin coko mu munne ti?",
    startBusinessUserPrompt: "N makaamoo bita lataramoo to",
    findHealthcareUserPrompt: "Mbe kenda-yaa dulaa kibaroo soto minto?",
    educationServicesUserPrompt: "Karandiri baaralu munne soto nna dingingolu ye?",
    transportLicensesUserPrompt: "Ñaadi mbe nna moto laisins kurandi?",
    housingProgramsUserPrompt: "Maa Keniya suw baaralu kang (affordable housing)",
    findJobsUserPrompt: "Gomnati baara munne ka nyining saaying?",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "Act as a helpful Kenyan civil registration expert. Explain the steps for obtaining a National ID (Maisha Namba) or replacing a lost one. IMPORTANT: Provide a clear list of required documents (e.g., Birth Certificate, copies of parents' IDs) and advise the user to visit their nearest Huduma Centre or Registrar of Persons office. RULE: Always refer to the application as 'Genie AI'.",

    payTaxesPrompt: "Act as a KRA (Kenya Revenue Authority) guide. Explain the process of filing returns, applying for a KRA PIN, or resetting a password on the iTax portal. IMPORTANT: Remind the user of the June 30th deadline for annual returns and guide them on how to file Nil returns if they had no income. RULE: Always refer to the application as 'Genie AI'.",

    startBusinessPrompt: "Act as a business consultant for eCitizen services. Guide the user through business name reservation and company registration in Kenya. IMPORTANT: Explain the current costs for name search and registration, and direct the user to the official eCitizen portal to complete the application. RULE: Always refer to the application as 'Genie AI'.",

    findHealthcarePrompt: "Act as a health services navigator. Provide information on the transition from NHIF to SHIF (Social Health Insurance Fund) and how to register. IMPORTANT: Share the official USSD codes (like *263#) or website links for registration and explain the benefits of the public health cover. RULE: Always refer to the application as 'Genie AI'.",

    educationServicesPrompt: "Act as an education counselor. Discuss the CBC curriculum, NEMIS registration, or university placement via KUCCPS. IMPORTANT: Explain how parents can check national exam results via SMS or the KNEC portal when released. RULE: Always refer to the application as 'Genie AI'.",

    transportLicensesPrompt: "Act as an NTSA service guide. Explain the process for driving license renewal, vehicle inspection, or TIMS account management. IMPORTANT: Guide the user on how to log in to the eCitizen NTSA portal to apply for their Smart DL or book a vehicle inspection. RULE: Always refer to the application as 'Genie AI'.",

    housingProgramsPrompt: "Act as a housing program advisor. Explain the Affordable Housing Program (Boma Yangu) registration and voluntary contribution process. IMPORTANT: Guide the user to the Boma Yangu portal to view projects and explain the eligibility criteria for allocation. RULE: Always refer to the application as 'Genie AI'.",

    findJobsPrompt: "Act as a career coach for the public service. Guide the user on creating a profile and applying for vacancies via the Public Service Commission (PSC) portal. IMPORTANT: Advise the user to keep their academic certificates ready and to regularly check the PSC website or local dailies for MyGov advertisements. RULE: Always refer to the application as 'Genie AI'.",

    justChatPrompt: "Act as a friendly local companion. Be polite, helpful, and knowledgeable about Kenyan culture and daily life. IMPORTANT: Remind the user that while you can chat about anything, your main strength is helping them navigate Kenyan government services like **IDs**, **Taxes**, and **Business Registration**. RULE: Always refer to the application as 'Genie AI'."
  },
  common: {
    cancel: 'A bula',
    create: 'Dada',
    save: 'Mara',
    move: 'Tita',
    delete: 'Fiti',
    ok: 'A benta',
    ingest: 'Dung',
    retract: 'Botata',
    loading: 'A ka looti...',
    refresh: 'Kurandi'
  },
  feedback: {
    title: 'Jaabi',
    button: 'Jaabi',
    positive: 'Jaabi beto',
    negative: 'Jaabi jaw',
    promptText: 'Nying jaabi beteyata-le?',
    placeholder: 'Kuma doolu...',
    submit: 'Jaabi Kii',
    close: 'A bula',
    thankYouMessage: 'Abaraka i la jaabi la!',
    submitting: 'A ka kii...',
    error: 'Filiyata. I si a ñining tugung.',
    success: 'Abaraka i la jaabi la!',
  },
  responseRating: {
    title: 'M Makaamoo Lataramoo to',
    note: 'I la jaabi si makaamoo ka chatboto dadiyaa waatoo naa-too.',
    chatbotResponse: 'Chatboto Jaabi:',
    ratingLabels: {
      1: 'Ti beteyaa (Useless)',
      2: 'A benta-doo',
      3: 'A benta-teema',
      4: 'A beteyata baa',
      5: 'Baara-kanya (Life Changing)'
    },
    additionalComments: 'Kuma doolu...',
    submit: 'Kii',
    cancel: 'A bula'
  },
  upload: {
    alt: 'Yele'
  },
  details: {
    loading: 'Fayil Kibaro ka looti...',
    title: 'Fayil Kibaroo',
    close: 'A dade',
    fileName: 'Fayil Toh',
    author: 'Tiyaa',
    labels: 'Mata-kumol',
    selectAll: 'Bee Ceng',
    loadingLabels: 'Mata-kumol ka looti...',
    status: 'Cokoyaa',
    fileId: 'Fayil ID',
    fileType: 'Fayil Suko',
    viewFile: 'Fayil Luka',
    visitLink: 'Taa banta-linkoo to',
    openFile: 'Fayiloo yele dulaa kura to',
    fileSize: 'Fayil Warayaa',
    uploadDate: 'Yele Lung',
    hash: 'SHA256 Has',
    tabs: {
      details: "Kibaroo",
      ingestionLog: "Dung Log"
    },
    log: {
      killActions: "Faha Kewol (Kill Actions):",
      killDocument: "Nying Dokuuma Faha",
      killProcess: "Dung Lataramoo Faha",
      timestamp: "Waatoo",
      level: "Jukuto",
      stage: "Dulaa",
      message: "Kilaa",
      loadingLogs: "Logolu ka looti...",
      noLogs: "Logolu mang je."
    },
    buttons: {
      saveMetadata: 'Metadeta Mara',
      retract: 'Botata',
      ingest: 'Dung'
    },
    notifications: {
      loadError: 'Filiyata fayil kibaro looti to.',
      validationError: 'Fayil Toh ani Tiyaa lafiya-le.',
      saveSuccess: 'Metadeta yailamata benta.',
      saveError: 'Filiyata metadeta mara to.',
      tokenError: 'Kumpabo tokin mang je moo kibaroo to.',
      viewError: 'Filiyata fayil luka to.',
      ingestSuccess: 'Fayiloo laata ka dung benta.',
      ingestError: 'Filiyata dung damina to.',
      retractSuccess: 'Fayiloo botata benta.',
      retractError: 'Filiyata fayiloo bota to.',
      deleteSuccess: 'Fayiloo fitita benta.',
      deleteError: 'Filiyata fayiloo fiti to.',
      ingestLabelRequired: "Ibay dii mata-kuma kiling ceng folo i ye dung.",
      ingestSaving: "A ka metadeta mara folo ka dung...",
      ingestSaveFailed: "Filiyata metadeta mara to. Dung ti baara.",
      logError: "Filiyata dung log looti to.",
      killDocSent: "Nying dokuuma faha kilaa kiyata.",
      killProcSent: "Dung lataramoo faha kilaa kiyata."
    },
    confirm: {
      ingest: 'I lafiya la ka nying fayiloo dung le ti? Nying si data lataramoo damina.',
      retract: 'I lafiya la ka nying fayiloo bota le ti?',
      delete: 'I lafiya la ka nying fayiloo fiti abada le ti? Nying kwoo mang si murung.',
      ingestTitle: "Dung Kumpabo",
      retractTitle: "Bota Kumpabo",
      deleteTitle: "Fiti Kumpabo",
      killDocTitle: "Dokuuma Dung Faha",
      killDoc: "I lafiya la ka dung baara faha nying dokuuma ye le ti? Sistem si koo ka a murung beto-coko.",
      killProcTitle: "Dung Lataramoo BEE Faha",
      killProc: "KANKUTAY: Nying si sistem dung baara bee faha. I kumpabota le baa ti?"
    }
  },
  uploadDialog: {
    title: 'Fayilolu Yele',
    dropzone: 'Fayilolu sika jang, wala piti ka ceng',
    allowedTypesLabel: 'Fayil sukol sota:',
    buttonUpload: 'Fayil {count} Yele',
    remove: 'Bota',
    uploading: 'A ka yele...',
    notifications: {
      dropError: 'Fayilolu dorong si sika jang. Ibay dii kumpabo ko fayiloo beteyata le.',
      typeNotAllowed: 'Fayil suko "{extension}" mang sota.',
      shortcutUnsupported: 'Sootkot fayilolu (.url) mang sota. Ibay dii fayil kiling sika.',
      duplicate: 'Fayil "{fileName}" kafuta le folo.',
      uploadSuccess: '{fileName} yeleta benta',
      uploadFailed: 'Filiyata {fileName} yele to.'
    }
  }
}